import { Dispatch } from 'redux';
import { typedAction } from 'store/modules/base';
import {
  AprovarOuReprovarCredenciamentoEmissorRequest,
  AtivarDesativarParametrizacoesRequest,
  CommandResultTyped,
} from 'common/genericTypes';
import { GETParametrizacoes, PUTAtivarDesativarParametrizacoes } from 'requests/parametrizacao';
import { ParametrizacoesResponse } from '../parametrizacoes/parametrizacoesResponse';

export interface ParametrizacoesApiState {
  getParametrizacoes(
    dispatch: Dispatch,
    stackRequest?: boolean
  ): Promise<CommandResultTyped<ParametrizacoesResponse[]>>;
  putAtivarDesativarParametrizacoes(
    dispatch: Dispatch,
    ativarDesativarParametrizacao: Array<AtivarDesativarParametrizacoesRequest>,
    stackRequest?: boolean
  ): Promise<any>;
}

const parametrizacaoApiInitialState: ParametrizacoesApiState = {
  getParametrizacoes: GETParametrizacoes,
  putAtivarDesativarParametrizacoes: PUTAtivarDesativarParametrizacoes,
};

enum ParametrizacaoApiActionType {
  Update = 'parametrizacaoApi/UPDATE',
  Reset = 'parametrizacaoApi/RESET',
}

export const updateParametrizacaoApi = (state: ParametrizacoesApiState) => {
  return typedAction(ParametrizacaoApiActionType.Update, state);
};

export const resetParametrizacaoApi = () => {
  return typedAction(ParametrizacaoApiActionType.Reset);
};

type ParametrizacaoApiAction = ReturnType<typeof updateParametrizacaoApi | typeof resetParametrizacaoApi>;

export function parametrizacaoApiReducer(
  state: ParametrizacoesApiState = parametrizacaoApiInitialState,
  action: ParametrizacaoApiAction
): ParametrizacoesApiState {
  switch (action.type) {
    case ParametrizacaoApiActionType.Update:
      return { ...action.payload };
    case ParametrizacaoApiActionType.Reset:
      return { ...parametrizacaoApiInitialState };
    default:
      return state;
  }
}
